<template>
    <div :class="classe">
        <label class="dx-field-item-label dx-field-item-label-location-top labelFormulario" v-if="titulo" :title="hint">
            <span class="dx-field-item-label-content">
                <span class="dx-field-label-text" v-html="titulo"></span>
                <span class="dx-field-item-required-mark" v-if="obrigatorio">&nbsp;*</span>
            </span>
        </label>
        <slot></slot>        
    </div>
</template>

<script>
    export default {
        props: {
            largura: {
                type: String,
                default: "col-12"
            },
            obrigatorio: Boolean,
            titulo: String,
            hint: String
        },
        computed: {
            classe() {
                return "form-group "+ this.largura;
            }
        }
    }

</script>

<style lang="scss">
// Tarefa #94819
.labelFormulario {
    margin-bottom: 5px !important;
    margin-top: 7px !important;
}
</style>